module.exports = __webpack_public_path__ + "static/media/OV.fb62eefb.png";